export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-1.52da690f.png";